import { reducerWithInitialState } from "typescript-fsa-reducers"
import { compensationStartDateActions } from "../actions/CompensationStartDateAction"

export interface CompensationStartDateState {
  compensationStartDate: string
}
const initialState: CompensationStartDateState = {
  compensationStartDate: ""
}
// Reduxを利用した画面間共通のCompensationStartDateState初期化処理
export const compensationStartDateReducer = reducerWithInitialState(initialState)
  .case(compensationStartDateActions.updateCompensationStartDate, (state, compensationStartDate) => {
    return { ...state, compensationStartDate }
  })
  .default((state) => {
    return state
  })
